import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#mortgage-loan-limits-app', App);
